var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !_setup.reload
    ? _c(
        _setup.Portal,
        {
          attrs: { to: "modal-container", disabled: _setup.disabled, slim: "" },
        },
        [
          _c(
            "div",
            {
              ref: "modal",
              staticClass: "modal fade",
              attrs: { role: "dialog", tabindex: "-1" },
            },
            [
              _c(
                "div",
                {
                  staticClass: "modal-dialog modal-dialog-scrollable",
                  class: {
                    "modal-lg": _vm.large && !_vm.extraLarge,
                    "modal-xl": _vm.extraLarge,
                    "modal-xxl": _vm.xxl,
                    "modal-dialog-centered": _vm.centered,
                  },
                  attrs: { role: "document" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "modal-content" },
                    [_vm._t("default")],
                    2
                  ),
                ]
              ),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }